var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEsSelector = function SvgEsSelector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_5_5",
    "data-name": "Component 5 \\u2013 5",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 32,
    height: 16,
    rx: 6,
    transform: "translate(13)",
    fill: "#f4b400"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(30 1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "EN",
    transform: "translate(6 12)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.377,
    y: 0
  }, "EN")), /*#__PURE__*/React.createElement("text", {
    id: "ES",
    transform: "translate(52 12)",
    fill: "#707070",
    fontSize: 10,
    fontFamily: "Roboto-Medium, Roboto",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -5.845,
    y: 0
  }, "ES")))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEsSelector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/es_selector.4e12c06d.svg";
export { ForwardRef as ReactComponent };